import Vue from "vue";
import Router from "vue-router";
import routes from "./routers";
import store from "@/store";
import iView from "iview";
import { removeToken, getToken, setTitle } from "@/libs/util";
import config from "@/config";
const { homeName } = config;

Vue.use(Router);
const router = new Router({
  routes,
  mode: "history"
});
const LOGIN_PAGE_NAME = "login";
const SIGN_UP_PAGE_NAME = "sign-up";

const turnTo = next => {
  next();
};

const toLogin = () => {
  removeToken();
  window.localStorage.removeItem("tagNaveList");
  window.location = "/login";
};

// 这里不去请求后台，而是从缓存中获取模块数据，用户登录的时候清除一个缓存并将模块缓存起来，用户注销的时候清除缓存
const token = getToken();

if (token) {
  let modules = window.localStorage.getItem(config.storage.MODULES);
  if (modules) {
    store.dispatch("setModules", {
      modules: modules ? JSON.parse(modules) : [],
      router
    });
  }
}

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  const token = getToken();
  if (!token && to.name !== LOGIN_PAGE_NAME && to.name !== SIGN_UP_PAGE_NAME) {
    // 未登录且要跳转的页面不是登录页
    toLogin();
  } else if (
    !token &&
    (to.name === LOGIN_PAGE_NAME || to.name === SIGN_UP_PAGE_NAME)
  ) {
    // 未登陆且要跳转的页面是登录页
    next(); // 跳转
  } else if (
    token &&
    (to.name === LOGIN_PAGE_NAME || to.name === SIGN_UP_PAGE_NAME)
  ) {
    // 已登录且要跳转的页面是登录页
    next({
      name: homeName // 跳转到homeName页
    });
  } else {
    if (store.state.app.user && Object.keys(store.state.app.user).length) {
      turnTo(next);
    } else {
      Vue.prototype
        .$api("app/currentUser")
        .then(user => {
          if (user) {
            store
              .dispatch("setUser", {
                ...user.userInfo,
                funCodes: user.funCodes
              })
              .then(() => {
                turnTo(next);
              });
          } else {
            toLogin();
          }
        })
        .catch(() => {
          toLogin();
        });
    }
  }
});

router.afterEach(to => {
  setTitle(to, router.app);
  iView.LoadingBar.finish();
  window.scrollTo(0, 0);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js